var map = {
	"./ion-action-sheet-ios.entry.js": [
		521,
		36
	],
	"./ion-action-sheet-md.entry.js": [
		522,
		37
	],
	"./ion-alert-ios.entry.js": [
		523,
		20
	],
	"./ion-alert-md.entry.js": [
		524,
		21
	],
	"./ion-app_8-ios.entry.js": [
		525,
		9
	],
	"./ion-app_8-md.entry.js": [
		526,
		10
	],
	"./ion-avatar_3-ios.entry.js": [
		527,
		38
	],
	"./ion-avatar_3-md.entry.js": [
		528,
		39
	],
	"./ion-back-button-ios.entry.js": [
		529,
		40
	],
	"./ion-back-button-md.entry.js": [
		530,
		41
	],
	"./ion-backdrop-ios.entry.js": [
		531,
		78
	],
	"./ion-backdrop-md.entry.js": [
		532,
		79
	],
	"./ion-button_2-ios.entry.js": [
		533,
		42
	],
	"./ion-button_2-md.entry.js": [
		534,
		43
	],
	"./ion-card_5-ios.entry.js": [
		535,
		44
	],
	"./ion-card_5-md.entry.js": [
		536,
		45
	],
	"./ion-checkbox-ios.entry.js": [
		537,
		46
	],
	"./ion-checkbox-md.entry.js": [
		538,
		47
	],
	"./ion-chip-ios.entry.js": [
		539,
		48
	],
	"./ion-chip-md.entry.js": [
		540,
		49
	],
	"./ion-col_3.entry.js": [
		541,
		80
	],
	"./ion-datetime_3-ios.entry.js": [
		542,
		16
	],
	"./ion-datetime_3-md.entry.js": [
		543,
		17
	],
	"./ion-fab_3-ios.entry.js": [
		544,
		50
	],
	"./ion-fab_3-md.entry.js": [
		545,
		51
	],
	"./ion-img.entry.js": [
		546,
		81
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		547,
		34
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		548,
		35
	],
	"./ion-input-ios.entry.js": [
		549,
		52
	],
	"./ion-input-md.entry.js": [
		550,
		53
	],
	"./ion-item-option_3-ios.entry.js": [
		551,
		54
	],
	"./ion-item-option_3-md.entry.js": [
		552,
		55
	],
	"./ion-item_8-ios.entry.js": [
		553,
		56
	],
	"./ion-item_8-md.entry.js": [
		554,
		57
	],
	"./ion-loading-ios.entry.js": [
		555,
		22
	],
	"./ion-loading-md.entry.js": [
		556,
		23
	],
	"./ion-menu_3-ios.entry.js": [
		557,
		58
	],
	"./ion-menu_3-md.entry.js": [
		558,
		59
	],
	"./ion-modal-ios.entry.js": [
		559,
		11
	],
	"./ion-modal-md.entry.js": [
		560,
		12
	],
	"./ion-nav_2.entry.js": [
		561,
		15
	],
	"./ion-popover-ios.entry.js": [
		562,
		13
	],
	"./ion-popover-md.entry.js": [
		563,
		14
	],
	"./ion-progress-bar-ios.entry.js": [
		564,
		60
	],
	"./ion-progress-bar-md.entry.js": [
		565,
		61
	],
	"./ion-radio_2-ios.entry.js": [
		566,
		62
	],
	"./ion-radio_2-md.entry.js": [
		567,
		63
	],
	"./ion-range-ios.entry.js": [
		568,
		64
	],
	"./ion-range-md.entry.js": [
		569,
		65
	],
	"./ion-refresher_2-ios.entry.js": [
		570,
		24
	],
	"./ion-refresher_2-md.entry.js": [
		571,
		25
	],
	"./ion-reorder_2-ios.entry.js": [
		572,
		32
	],
	"./ion-reorder_2-md.entry.js": [
		573,
		33
	],
	"./ion-ripple-effect.entry.js": [
		574,
		82
	],
	"./ion-route_4.entry.js": [
		575,
		66
	],
	"./ion-searchbar-ios.entry.js": [
		576,
		67
	],
	"./ion-searchbar-md.entry.js": [
		577,
		68
	],
	"./ion-segment_2-ios.entry.js": [
		578,
		69
	],
	"./ion-segment_2-md.entry.js": [
		579,
		70
	],
	"./ion-select_3-ios.entry.js": [
		580,
		71
	],
	"./ion-select_3-md.entry.js": [
		581,
		72
	],
	"./ion-slide_2-ios.entry.js": [
		582,
		83
	],
	"./ion-slide_2-md.entry.js": [
		583,
		84
	],
	"./ion-spinner.entry.js": [
		584,
		28
	],
	"./ion-split-pane-ios.entry.js": [
		585,
		85
	],
	"./ion-split-pane-md.entry.js": [
		586,
		86
	],
	"./ion-tab-bar_2-ios.entry.js": [
		587,
		73
	],
	"./ion-tab-bar_2-md.entry.js": [
		588,
		74
	],
	"./ion-tab_2.entry.js": [
		589,
		31
	],
	"./ion-text.entry.js": [
		590,
		75
	],
	"./ion-textarea-ios.entry.js": [
		591,
		76
	],
	"./ion-textarea-md.entry.js": [
		592,
		77
	],
	"./ion-toast-ios.entry.js": [
		593,
		26
	],
	"./ion-toast-md.entry.js": [
		594,
		27
	],
	"./ion-toggle-ios.entry.js": [
		595,
		18
	],
	"./ion-toggle-md.entry.js": [
		596,
		19
	],
	"./ion-virtual-scroll.entry.js": [
		597,
		87
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 253;
module.exports = webpackAsyncContext;